const VerticalBook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Light / book-book-pages">
      <g id="book-book-pages">
        <path
          id="Shape"
          d="M11.5891 7.6734L21.5242 11.6459C21.9463 11.8145 22.2232 12.2231 22.2235 12.6776V31.4093C22.2229 31.7779 22.0398 32.1221 21.7345 32.3286C21.4292 32.535 21.0415 32.5767 20.6992 32.44L11.8048 28.8822C11.3831 28.7137 11.1062 28.3057 11.1055 27.8516V8.59176C11.1055 7.97772 11.6032 7.47995 12.2173 7.47995H27.7826C28.3966 7.47995 28.8944 7.97772 28.8944 8.59176V27.4924C28.8944 28.1065 28.3966 28.6043 27.7826 28.6043H25.5589"
          stroke="currentColor"
        />
        <path
          id="Shape_2"
          d="M11.7188 7.59781L24.6557 10.0849C25.1796 10.1852 25.5584 10.6433 25.5585 11.1767V29.7161C25.5585 30.3301 25.0607 30.8279 24.4467 30.8279H22.2231"
          stroke="currentColor"
        />
      </g>
    </g>
  </svg>
)

export default VerticalBook
